@if (reviewEnabled()) {
<section class="bn-review-home">
  <header class="bn-review-home__header">
    <div class="bn-review-home__heading">
      <h2 class="bn-review-home__title">AI Review</h2>
      <p class="bn-review-home__lede">
        Cases and actions Navi proposed from client conversations. You confirm before anything reaches the client.
      </p>
    </div>
    <div class="bn-review-home__meta">
      @if (!loading() && !error()) {
        <span>{{ activities().length }} {{ activities().length === 1 ? 'item' : 'items' }} awaiting confirmation</span>
      }
      <p-button
        icon="pi pi-refresh"
        severity="secondary"
        [text]="true"
        [rounded]="true"
        size="small"
        [loading]="loading()"
        ariaLabel="Refresh review queue"
        (onClick)="reload()"
      />
    </div>
  </header>

  <div class="bn-review-home__table-wrap">
    <table class="bn-review-home__table">
      <thead>
        <tr>
          <th>Received</th>
          <th>Client</th>
          <th>Customer</th>
          <th>Proposed activity</th>
          <th>What the client said</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr>
            <td class="bn-review-home__status" colspan="6">Loading activities…</td>
          </tr>
        } @else if (error(); as message) {
          <tr>
            <td class="bn-review-home__status" colspan="6" role="alert">{{ message }}</td>
          </tr>
        } @else if (activities().length === 0) {
          <tr>
            <td class="bn-review-home__status" colspan="6">No activities waiting for review.</td>
          </tr>
        } @else {
          @for (activity of activities(); track activity.activity_id) {
            <tr class="bn-review-home__row" (click)="open(activity)">
              <td class="bn-review-home__tight">
                <span class="bn-review-home__pill">{{ receivedLabel(activity) }}</span>
              </td>
              <td class="bn-review-home__tight">
                @if (clientGuid(activity)) {
                  <button
                    type="button"
                    class="bn-review-home__client"
                    (click)="openClient($event, activity)"
                  >
                    {{ clientName(activity) }}
                  </button>
                } @else {
                  {{ clientName(activity) }}
                }
              </td>
              <td class="bn-review-home__tight">{{ clientCustomer(activity) }}</td>
              <td class="bn-review-home__activity">{{ proposedActivity(activity) }}</td>
              <td class="bn-review-home__quote">{{ clientSaid(activity) }}</td>
              <td class="bn-review-home__tight">
                <div class="bn-review-home__actions">
                  <span class="bn-review-home__chip">{{ actionCount(activity) }}</span>
                  <button
                    type="button"
                    class="bn-review-home__link"
                    (click)="openFromLink($event, activity)"
                  >
                    Review
                  </button>
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  @if (!loading() && !error() && activities().length > 0) {
    <footer class="bn-review-home__pager">
      <span>Showing {{ activities().length }} items</span>
    </footer>
  }
</section>

@if (selectedActivity(); as activity) {
  <bn-activity-detail-dialog
    [activity]="activity"
    [visible]="detailVisible()"
    (visibleChange)="detailVisible.set($event)"
    (changed)="onActivityChanged()"
  />
}
}
